import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';


export interface IAuthStoreState {
	authCredentials: IAuthCredentials | null;
	promptedToAddToHomescreen: boolean;
}

export interface IAuthCredentials {
	locationBase: string;
	apiKey: string;
	host: string;
}


@Module({dynamic: true, store, name: 'auth'})
class Auth extends VuexModule implements IAuthStoreState {
	authCredentials: IAuthCredentials | null = null;
	promptedToAddToHomescreen = false;

	get loggedIn() {
		return this.authCredentials !== null;
	}

	@Action
	public setAuthCredentials(user: IAuthCredentials) {
		this.SET_AUTH_CREDENTIALS(user);
	}

	@Action
	public clearAuthCredentials() {
		this.CLEAR_AUTH_CREDENTIALS();
	}

	@Action
	public setPromptedToAddToHomescreen(value: boolean) {
		this.SET_PROMPTED_TO_ADD_TO_HOMESCREEN(value);
	}

	@Mutation
	public SET_AUTH_CREDENTIALS(user: IAuthCredentials) {
		this.authCredentials = user;
	}

	@Mutation
	public CLEAR_AUTH_CREDENTIALS() {
		this.authCredentials = null;
	}

	@Mutation
	public SET_PROMPTED_TO_ADD_TO_HOMESCREEN(value: boolean) {
		this.promptedToAddToHomescreen = value;
	}
}

export const AuthStore = getModule(Auth);
